export function sanitizeCardDescription (str) {
  return str.replaceAll(/<\/?p>/g, '')
}
